import AmexGDAB2BFooter from './AmexGDAB2BFooter';

export default AmexGDAB2BFooter;
